import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter, routerShape } from 'react-router';
import updateSearchQuery from '../../helpers/search/updateSearchQuery';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { searchEventComposer } from '@bibliocommons/analytics-event-composers';

import './DidYouMean.scss';

export class DidYouMean extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleClick');
  }

  componentDidMount() {
    if (this.props.querySuggestion && this.props.handleDidYouMeanImpression) {
      this.props.handleDidYouMeanImpression();
    }
  }

  handleClick(e) {
    e.preventDefault();
    const { router, location } = this.props;
    sendAnalyticsEvents(searchEventComposer.composeDidYouMeanClickEvent({ query: location.query.query, suggestion: this.props.querySuggestion }));

    const query = updateSearchQuery({
      currentQuery: location.query,
      query: this.props.querySuggestion,
      pagination_page: undefined
    });

    router.push({ ...location, query });
  }

  render() {
    const { querySuggestion, resultCount } = this.props;
    if (!querySuggestion) {
      return null;
    }

    return (
      <div className="cp-did-you-mean">
        <FormattedMessage id="form_label_did_you_mean" values={{ querySuggestion: <strong>{querySuggestion}</strong> }} />
        &nbsp;
        <a className="did-you-mean-suggestion-link" href="#dym" onClick={this.handleClick}>
          <FormattedMessage id="form_label_did_you_mean_view_results" values={{ resultCount }} />
        </a>
      </div>
    );
  }
}

DidYouMean.displayName = 'DidYouMean';

DidYouMean.propTypes = {
  querySuggestion:  PropTypes.string,
  resultCount:      PropTypes.number,
  handleDidYouMeanImpression: PropTypes.func,
  router: routerShape
};

export default withRouter(DidYouMean);



// WEBPACK FOOTER //
// ./app/components/search/DidYouMean.jsx